import { DateTime } from "luxon";
import tools from "../../../helpers/tools";
import SynchroFTStatus from "../RecipientDetail/SynchroFTStatus";

const RecipientOrientation = ({ recipient, orgs }) => {
  return (
    <div className="row">
      {recipient && recipient.lastOrientation && (
        <div className="col-12 mb-2">
          <div className="card rounded">
            <div className="card-body py-2 ">
              <div
                className="d-flex flex-wrap justify-content-start align-items-center w-100"
                style={{ gap: 10 }}
              >
                <div
                  className="py-2 d-flex align-items-center justify-content-start flex-wrap"
                  style={{ gap: 10 }}
                >
                  <span
                    className="badge bg-body border"
                    style={{ width: "fit-content" }}
                  >
                    Orientation
                  </span>
                  {
                    <strong>
                      {tools.findIn(
                        orgs,
                        "slugName",
                        recipient.lastOrientation.orientation,
                      ).name || "N.D"}
                    </strong>
                  }
                  <div className="text-muted" style={{ fontSize: 12 }}>
                    le{" "}
                    {DateTime.fromISO(
                      recipient.lastOrientation.createdAt,
                    ).toFormat("dd/MM/yyyy")}
                  </div>
                </div>
                <div
                  className="py-2 d-flex align-items-center justify-content-start flex-wrap"
                  style={{ gap: 10 }}
                >
                  {/* {recipient.lastOrientation?.createdAt &&
                    DateTime.fromISO(recipient.lastOrientation.createdAt) >
                      DateTime.fromISO("2025-01-01T00:00:00.000Z") && ( */}
                  <SynchroFTStatus
                    categorie="ORIENTATION"
                    entiteId={recipient?.lastOrientation?.orientationId}
                  />

                  {/* )} */}
                </div>
              </div>
              {recipient.lastOrientation.updatedAt && (
                <div
                  className="py-2 d-flex align-items-center justify-content-start flex-wrap"
                  style={{ gap: 10 }}
                >
                  <span
                    className="badge badge-info"
                    style={{ width: "fit-content" }}
                  >
                    Maintien
                  </span>
                  <div className="text-muted" style={{ fontSize: 12 }}>
                    le{" "}
                    {DateTime.fromISO(
                      recipient.lastOrientation.updatedAt,
                    ).toFormat("dd/MM/yyyy")}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default RecipientOrientation;
